<script>
import axios from 'axios'
import DeviceIdModal from '@/vcs/_shared/modals/DeviceIdModal.vue'
import LogModal from '@/vcs/_shared/modals/LogModal.vue'
const SECONDS_TO_SESSION_CLEARING = 10

export default {
  name: 'ReconnectBlocker',
  data: function () {
    return {
      timer: SECONDS_TO_SESSION_CLEARING
    }
  },
  mounted() {
    this.setRecconnectInterval()
  },
  beforeDestroy() {
    this.clearRecconnectInterval()
  },
  methods: {
    setRecconnectInterval() {
      window.reconnectInterval = setInterval(() => {
        this.timer > 1
          ? this.timer--
          : this.fetchCpInfo(window.localStorage.getItem('device_id'))
      }, 1000)
    },

    clearRecconnectInterval() {
      clearInterval(window.reconnectInterval)
      this.timer = SECONDS_TO_SESSION_CLEARING
    },

    selfCloseThisCmp() {
      this.$store.commit('blockUIReconnect', false)
    },

    setDeviceId() {
      this.$store.commit('modal/open', {
        cmp: DeviceIdModal,
        canBackrdopClose: true,
        callback: () => {
          this.selfCloseThisCmp()
        }
      })
    },

    fetchCpInfo(deviceId) {
      this.$blockUI()
      axios({
        method: 'get',
        url: `collection_points/${deviceId}/map`
      })
        .then((response) => {
          this.clearRecconnectInterval()
          this.selfCloseThisCmp()
        })
        .catch((error) => {
          this.$store.commit('addLogEntry', {
            message: '/map',
            deviceId: deviceId,
            error: error,
            time: new Date()
          })
          this.clearRecconnectInterval()
          this.setRecconnectInterval()
        })
        .finally(() => {
          this.$unblockUI()
        })
    },

    showLogs() {
      this.$store.commit('modal/open', {
        cmp: LogModal,
        size: 'full'
      })
    }
  }
}
</script>

<template lang="pug">
transition(name="fade")
  .timeout-alert
    .timeout-alert__inner
      span.mr-4 Łącze się z serwerem
      .spinner
      button.btn.btn-sm.btn-text.btn-fixed-left(type="button" v-ea-click="setDeviceId") {{ $t('authorizeId') }}
      button.btn.btn-sm.btn-text.btn-fixed-right(type="button" v-ea-click="showLogs") show logs
</template>

<style scoped lang="scss">
@import '@/assets/styles/variables.scss';

.timeout-alert {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;

  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  // z-index: 9999;

  .timeout-alert__inner {
    padding: 3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;

    text-align: center;
    font-size: 2.4rem;
    color: white;
    background: white;

    width: 36rem;
    border-radius: 4px;
    background: $danger;

    .timeout-alert__timer {
      font-size: 4rem;
      line-height: 1;
      margin-bottom: 2rem;
    }
  }

  @keyframes donut-spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .spinner {
    display: inline-block;
    border: 3px solid rgba(0, 0, 0, 0.1);
    border-left-color: white;
    border-radius: 50%;
    width: 4rem;
    height: 4rem;
    animation: donut-spin 1.2s linear infinite;
  }
}

.btn-fixed-left {
  position: fixed;
  left: 0;
  bottom: 0;
}

.btn-fixed-right {
  position: fixed;
  right: 0;
  bottom: 0;
}
</style>
